import { clsx } from 'clsx'

import { Button, ButtonVariant } from '../Button/index.js'

export type TopBarButtonProps = React.ComponentPropsWithoutRef<'button'> & {
  variant?: ButtonVariant
  disabled?: boolean
}

export const TopBarButton = ({
  children,
  variant = 'outline',
  ...rest
}: TopBarButtonProps) => {
  return (
    <Button
      variant={variant}
      rounded
      className={clsx('w-10 h-10 px-0 justify-center flex-shrink-0')}
      {...rest}
    >
      {children}
    </Button>
  )
}
